<template>
  <div class="min-h-screen bg-slate-900 flex flex-col font-sans text-slate-50 selection:bg-primary-500/30">
    <AppHeader />
    
    <main class="flex-1">
      <router-view />
    </main>

    <AppFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AppHeader from '@/components/AppHeader.vue';
import AppFooter from '@/components/AppFooter.vue';

export default defineComponent({
  name: 'App',
  components: {
    AppHeader,
    AppFooter
  }
});
</script>

<style>
/* Global overrides if needed */
</style>
